import PropTypes from "prop-types";
import styles from "./styles/switch.module.css";

export function Switch({ isBra = false, isCM = false, handleToggle }) {
  if (isBra) {
    return null;
  }

  const inchesBtnStyles = `
  ${styles.unitsBtn}
  ${!isCM ? styles.unitsBtnSelected : ""}`;

  const cmBtnStyles = `
  ${styles.unitsBtn}
  ${isCM ? styles.unitsBtnSelected : ""}`;

  return (
    <ul className={styles.switch}>
      <li>
        <button className={cmBtnStyles} onClick={handleToggle}>
          CM
        </button>
      </li>
      <li>
        <button className={inchesBtnStyles} onClick={handleToggle}>
          IN
        </button>
      </li>
    </ul>
  );
}

Switch.propTypes = {
  isBra: PropTypes.bool,
  isCM: PropTypes.bool,
  handleToggle: PropTypes.func.isRequired,
};
